module.exports = __webpack_public_path__ + "static/media/ProductSettings_white.2a4ef0b7.svg";